import React from "react";
import "./Verification.css";

export default function Verification(props) {
  const openApp = () => {
    window.location = "com.searates-connect://";
  };
  return (
    <div className="align-center align-center-verification">
      <div className="verification-box">
        <div className={props.success ? "success-icon" : "fail-icon"} />
        <div className="verification-text">
          {props.success ? (
            <>
              <h1>Verification Successful</h1>
              <h2>
                Thank you for your support, we have successfully verified your
                email.
              </h2>
            </>
          ) : (
            <>
              <h1>Verification Failed</h1>
              <h2>
                Your email address could not be verified due either you have
                already verified your email address or verification times has
                lapsed.
              </h2>
            </>
          )}

          <button className="button" onClick={openApp}>
            GO TO APP
          </button>
        </div>
      </div>
    </div>
  );
}
